var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBmp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25831",
    "data-name": "Group 25831",
    transform: "translate(-1005 -489)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13722",
    "data-name": "Rectangle 13722",
    width: 22,
    height: 25,
    transform: "translate(1005 489)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bmp-file-format-symbol",
    transform: "translate(973.496 489)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8072",
    "data-name": "Path 8072",
    d: "M117.224,312.417c0-.632-.566-.882-1.272-.882h-.482V313.3a4.543,4.543,0,0,0,.548.018C116.658,313.318,117.224,313.076,117.224,312.417Z",
    transform: "translate(-80.181 -297.491)",
    fill: "#acacac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8073",
    "data-name": "Path 8073",
    d: "M52.1,8.881h-.6V6A.422.422,0,0,0,51.5,5.95a.477.477,0,0,0-.116-.315L46.6.167l0,0a.479.479,0,0,0-.1-.081L46.465.063a.511.511,0,0,0-.1-.04L46.343.014A.493.493,0,0,0,46.231,0H34.466a.975.975,0,0,0-.974.974V8.881h-.6A1.392,1.392,0,0,0,31.5,10.273V17.51A1.392,1.392,0,0,0,32.9,18.9h.6v4.954a.975.975,0,0,0,.974.974H50.532a.975.975,0,0,0,.974-.974V18.9h.6a1.392,1.392,0,0,0,1.392-1.392V10.273A1.392,1.392,0,0,0,52.1,8.881ZM34.466.974H45.744V5.956a.487.487,0,0,0,.487.487h4.3V8.882H34.466Zm11.8,15.838H44.882l-.093-2.4c-.028-.752-.056-1.662-.056-2.572H44.7c-.2.8-.455,1.69-.7,2.424l-.761,2.442h-1.1l-.669-2.423c-.2-.734-.418-1.625-.566-2.442h-.019c-.037.845-.066,1.811-.112,2.591l-.111,2.378H39.356l.4-6.259h1.885l.613,2.09c.195.724.39,1.5.529,2.238h.028c.177-.725.39-1.551.594-2.247l.669-2.08h1.848Zm-12.379-.029V10.636a11.221,11.221,0,0,1,1.83-.13,3.461,3.461,0,0,1,1.848.353,1.363,1.363,0,0,1,.752,1.226,1.414,1.414,0,0,1-1.031,1.337v.019a1.566,1.566,0,0,1,1.244,1.541,1.669,1.669,0,0,1-.649,1.328,3.955,3.955,0,0,1-2.461.566A10.981,10.981,0,0,1,33.886,16.783Zm16.646,6.809H34.466V18.9H50.532v4.69Zm.738-9.651a2.9,2.9,0,0,1-2.034.659,3.65,3.65,0,0,1-.482-.028v2.238h-1.4V10.636a11.527,11.527,0,0,1,1.913-.13,3,3,0,0,1,1.913.5,1.83,1.83,0,0,1,.669,1.449A2,2,0,0,1,51.27,13.942Z",
    transform: "translate(0)",
    fill: "#acacac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8074",
    "data-name": "Path 8074",
    d: "M414.74,256.727a2.4,2.4,0,0,0-.585.056v1.847a2.147,2.147,0,0,0,.473.037c.753,0,1.217-.38,1.217-1.021C415.845,257.07,415.446,256.727,414.74,256.727Z",
    transform: "translate(-365.401 -245.154)",
    fill: "#acacac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8075",
    "data-name": "Path 8075",
    d: "M117.071,256.625c0-.473-.362-.725-1-.725a3.871,3.871,0,0,0-.6.037V257.4h.464C116.671,257.4,117.071,257.09,117.071,256.625Z",
    transform: "translate(-80.175 -244.364)",
    fill: "#acacac"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBmp);
export default __webpack_public_path__ + "static/media/bmp.98304b6a9b8d460d42616a50aa6d2254.svg";
export { ForwardRef as ReactComponent };